import React from 'react';

import { Row, Form, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';

import { Button } from '../../../components';
import { customStyles, formatSocial } from '../utils';

import './styles.scoped.css';

const DeductionRegisterForm = ({
  setForm,
  form,
  isLoadingDeductions,
  deductionSortOptions,
  isLoadingBranches,
  branchOptions,
  handleViewResults,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleChange = e => {
    const _form = { ...form, [e.target.name]: e.target.value };
    setForm(_form);
  };
  return (
    <Form
      noValidate
      onSubmit={() => {}}
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}>
      <div className="filters-row">
        <div
          className="filter-row"
          style={{
            marginTop: '30px',
          }}>
          <Form.Group as={Row} controlId="FromPerEnddate" style={{ alignItems: 'center' }}>
            <Form.Label style={{ width: '290px' }}>Period End Date</Form.Label>
            <Form.Control
              style={{
                width: '150px',
                height: '30px',
                marginRight: '20px',
              }}
              as="input"
              type="date"
              name="FromPerEnddate"
              defaultValue={form?.FromPerEnddate}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group as={Row} controlId="ToPerEnddate" style={{ alignItems: 'center' }}>
            <Form.Label
              style={{
                width: '20px',
                marginLeft: '30px',
                marginRight: '20px',
              }}>
              To
            </Form.Label>
            <Form.Control
              style={{
                width: '150px',
                height: '30px',
              }}
              as="input"
              type="date"
              name="ToPerEnddate"
              defaultValue={form?.ToPerEnddate}
              onChange={handleChange}
            />
            <Form.Control.Feedback type="invalid" />
          </Form.Group>
        </div>
        <div className="filter-row" style={{ marginLeft: '5ch' }}>
          <b>OR</b>
        </div>
        <div
          className="filter-row"
          style={{
            marginTop: '30px',
          }}>
          <Form.Group as={Row} controlId="FromCheckdate" style={{ alignItems: 'center' }}>
            <Form.Label style={{ width: '290px' }}>Check Date</Form.Label>
            <Form.Control
              style={{
                width: '150px',
                height: '30px',
                marginRight: '20px',
              }}
              as="input"
              type="date"
              name="FromCheckdate"
              value={form?.FromCheckdate ?? ''}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group as={Row} controlId="ToCheckdate" style={{ alignItems: 'center' }}>
            <Form.Label
              style={{
                width: '20px',
                marginLeft: '30px',
                marginRight: '20px',
              }}>
              To
            </Form.Label>
            <Form.Control
              style={{
                width: '150px',
                height: '30px',
              }}
              as="input"
              type="date"
              name="ToCheckdate"
              value={form?.ToCheckdate ?? ''}
              onChange={handleChange}
            />
            <Form.Control.Feedback type="invalid" />
          </Form.Group>
        </div>
        <div className="filter-row">
          <Form.Group as={Row} controlId="FromEmplLastName" style={{ alignItems: 'center' }}>
            <Form.Label style={{ width: '290px' }}>
              {t('edge_reporting.deduction_register.driver')} Last Name
            </Form.Label>
            <Form.Control
              style={{
                width: '360px',
                height: '30px',
                marginRight: '20px',
              }}
              as="input"
              name="FromEmplLastName"
              defaultValue={form?.FromEmplLastName}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group as={Row} controlId="ToEmplLastName" style={{ alignItems: 'center' }}>
            <Form.Label
              style={{
                width: '20px',
                marginLeft: '30px',
                marginRight: '20px',
              }}>
              To
            </Form.Label>
            <Form.Control
              style={{
                width: '360px',
                height: '30px',
                marginRight: '20px',
              }}
              as="input"
              name="ToEmplLastName"
              defaultValue={form?.ToEmplLastName}
              onChange={handleChange}
            />
          </Form.Group>
        </div>

        <div className="filter-row">
          <Form.Group as={Row} controlId="FromEmplFirstName" style={{ alignItems: 'center' }}>
            <Form.Label style={{ width: '290px' }}>
              {t('edge_reporting.deduction_register.driver')} First Name
            </Form.Label>
            <Form.Control
              style={{
                width: '360px',
                height: '30px',
                marginRight: '20px',
              }}
              as="input"
              name="FromEmplFirstName"
              defaultValue={form?.FromEmplFirstName}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group as={Row} controlId="ToEmplFirstName" style={{ alignItems: 'center' }}>
            <Form.Label
              style={{
                width: '20px',
                marginLeft: '30px',
                marginRight: '20px',
              }}>
              To
            </Form.Label>
            <Form.Control
              style={{
                width: '360px',
                height: '30px',
                marginRight: '20px',
              }}
              as="input"
              name="ToEmplFirstName"
              defaultValue={form?.ToEmplFirstName}
              onChange={handleChange}
            />
          </Form.Group>
        </div>

        <div className="filter-row">
          <Form.Group as={Row} style={{ alignItems: 'center' }}>
            <Form.Label style={{ width: '290px' }}>{t('edge_reporting.deduction_register.driver')} Number</Form.Label>
            <Form.Control
              style={{
                width: '360px',
                height: '30px',
                marginRight: '20px',
              }}
              as="input"
              name="FromEmplID"
              value={form?.FromEmplID}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group as={Row} controlId="ToEmplID" style={{ alignItems: 'center' }}>
            <Form.Label
              style={{
                width: '20px',
                marginLeft: '30px',
                marginRight: '20px',
              }}>
              To
            </Form.Label>
            <Form.Control
              style={{
                width: '360px',
                height: '30px',
                marginRight: '20px',
              }}
              as="input"
              name="ToEmplID"
              defaultValue={form?.ToEmplID}
              onChange={handleChange}
            />
          </Form.Group>
        </div>

        <div className="filter-row">
          <Form.Group as={Row} controlId="SSNO" style={{ alignItems: 'center' }}>
            <Form.Label style={{ width: '290px' }}>SSN</Form.Label>
            <Form.Control
              style={{
                width: '150px',
                height: '30px',
                marginRight: '20px',
              }}
              as="input"
              name="SSNO"
              value={formatSocial(form?.SSNO || '')}
              onChange={handleChange}
            />
          </Form.Group>
        </div>
        <div className="filter-row">
          <Form.Group as={Row} controlId="deductionSort" style={{ alignItems: 'center' }}>
            <Form.Label style={{ width: '290px' }}>Deduction Code</Form.Label>
            <Select
              isDisabled={isLoadingDeductions}
              isMulti
              closeMenuOnSelect={false}
              styles={customStyles('365px')}
              options={deductionSortOptions}
              defaultValue={form?.DedCode?.split(',').map(code =>
                deductionSortOptions.find(option => option.value === code),
              )}
              onChange={selectedOptions => {
                const selectedCodes = selectedOptions.map(option => option.value);
                setForm({
                  ...form,
                  DedCode: selectedCodes.join(','),
                });
              }}
            />
            <Spinner
              as="span"
              animation="border"
              size="sm"
              aria-hidden="true"
              className="dropdown-spinner"
              hidden={!isLoadingDeductions}
            />
          </Form.Group>
        </div>
        <div className="filter-row">
          <Form.Group as={Row} controlId="FromBranch" style={{ alignItems: 'center' }}>
            <Form.Label style={{ width: '290px' }}>Branch</Form.Label>
            <div className="dropdown-spinner-container">
              <Select
                styles={customStyles('150px')}
                isDisabled={isLoadingBranches}
                options={branchOptions}
                isClearable
                onChange={(event, action) => {
                  if (action.action === 'clear') {
                    setForm({
                      ...form,
                      FromBranch: '',
                    });
                  }
                  if (action.action === 'select-option') {
                    setForm({
                      ...form,
                      FromBranch: event.value,
                    });
                  }
                }}
                defaultValue={branchOptions?.filter(option => option.value === form?.FromBranch)}
              />
              <Spinner
                as="span"
                animation="border"
                size="sm"
                aria-hidden="true"
                className="dropdown-spinner"
                hidden={!isLoadingBranches}
              />
            </div>
          </Form.Group>
          <Form.Group as={Row} controlId="ToBranch" style={{ alignItems: 'center' }}>
            <Form.Label
              style={{
                width: '20px',
                marginLeft: '55px',
                marginRight: '20px',
              }}>
              To
            </Form.Label>
            <div className="dropdown-spinner-container">
              <Select
                styles={customStyles('150px')}
                isDisabled={isLoadingBranches}
                options={branchOptions}
                isClearable
                onChange={(event, action) => {
                  if (action.action === 'clear') {
                    setForm({ ...form, ToBranch: '' });
                  }
                  if (action.action === 'select-option') {
                    setForm({
                      ...form,
                      ToBranch: event.value,
                    });
                  }
                }}
                defaultValue={branchOptions?.filter(option => option.value === form?.ToBranch)}
              />
              <Spinner
                as="span"
                animation="border"
                size="sm"
                aria-hidden="true"
                className="dropdown-spinner"
                hidden={!isLoadingBranches}
              />
            </div>
          </Form.Group>
        </div>
      </div>
      <div className="buttons-row">
        <Button variant="primary" onPress={() => handleViewResults()} style={{ marginRight: '20px', width: '100px' }} text="View" />

        <Button
          style={{ width: '100px' }}
          onPress={() => navigate('/edge-reporting')}
          variant="outline"
          text="Cancel"
        />
      </div>
    </Form>
  );
};

export default DeductionRegisterForm;
